/**
 * IdleState - Player is standing still on ground
 */

import BaseState from './BaseState';
import eventBus, { GameEvents } from '../../core/EventBus';

export default class IdleState extends BaseState {
    enter(data) {
        // Reset any movement effects
        if (this.player) {
            this.player.baseScaleX = 1;
            this.player.baseScaleY = 1;
        }
    }

    update(delta) {
        if (!this.player || this.player.isDead) return;

        const { cursors, wasd } = this.player;
        
        // Check for horizontal input -> Rolling
        const moveLeft = cursors.left.isDown || wasd.left.isDown;
        const moveRight = cursors.right.isDown || wasd.right.isDown;
        
        if (moveLeft || moveRight) {
            this.transitionTo('rolling');
            return;
        }

        // Check for jump input -> Jumping
        if (this.player.checkJumpInput()) {
            this.transitionTo('jumping');
            return;
        }

        // Check if no longer grounded -> Falling
        if (!this.player.isGrounded) {
            this.transitionTo('falling');
            return;
        }

        // Apply friction to slow down any residual movement
        const velocity = this.sprite.body.velocity;
        if (Math.abs(velocity.x) > 0.1) {
            this.sprite.setAngularVelocity(this.sprite.body.angularVelocity * 0.9);
        }

        // Handle magnetic pull while idle
        this.player.handleMagneticPull();
    }

    exit() {
        // Nothing specific to clean up
    }
}
